"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contact = void 0;
var React = require("react");
var fa_1 = require("react-icons/fa");
var StyleComponents_1 = require("./base/StyleComponents");
var Contact = function () {
    return (React.createElement("div", { style: {
            padding: '2em 2em 2em 2em',
            //background: ' linear-gradient(5deg, white, rgb(193, 135, 6) 30%, rgb(193, 135, 6) 70%,  white)',
            backgroundImage: 'linear-gradient(rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.7) 100%), url("image/gallery/4.jpg")',
            backgroundSize: 'cover',
            color: 'white'
        } },
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap'
            } },
            React.createElement("div", { style: {
                    width: '50%',
                    minWidth: 300,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center'
                } },
                React.createElement("div", { style: { paddingBottom: '1em' } },
                    React.createElement("h3", { style: { marginBottom: '.5em', color: StyleComponents_1.goldColor } }, "KONTAKT"),
                    React.createElement("hr", null),
                    React.createElement(fa_1.FaEnvelope, null),
                    " ryszard.gut@wp.pl ",
                    React.createElement("br", null),
                    React.createElement(fa_1.FaEnvelope, null),
                    " kontakt@winnicaswidnicka.eu ",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement(fa_1.FaPhoneAlt, null),
                    " 662 043 709",
                    React.createElement("br", null),
                    React.createElement(fa_1.FaPhoneAlt, null),
                    " 604 901 954",
                    React.createElement("br", null)),
                React.createElement("div", null,
                    React.createElement("h3", { style: { marginBottom: '.5em', color: StyleComponents_1.goldColor } }, "ADRES"),
                    React.createElement("hr", null),
                    React.createElement("p", null,
                        React.createElement(fa_1.FaHome, null),
                        " WINNICA",
                        React.createElement("br", null),
                        "Makowice",
                        React.createElement("br", null),
                        "58-100 \u015Awidnica"),
                    React.createElement("p", null,
                        React.createElement(fa_1.FaHome, null),
                        " WINIARNIA/SKLEP",
                        React.createElement("br", null),
                        "ul. Kraszowicka 23",
                        React.createElement("br", null),
                        "58-100 \u015Awidnica",
                        React.createElement("br", null)))),
            React.createElement("div", { style: { width: '50%', minWidth: 300, boxShadow: '0 0 1em white' } },
                React.createElement("iframe", { style: {
                        marginBottom: '-10px'
                    }, width: "100%", height: "600", scrolling: "no", src: "https://maps.google.com/maps?width=100%25&height=600&hl=en&q=Winnica%20%C5%9Awidnicka+(My%20Business%20Name)&t=&z=13&ie=UTF8&iwloc=B&output=embed" })))));
};
exports.Contact = Contact;
//# sourceMappingURL=Contact.js.map